export function makeTerminologyLocale({ heard, patientContext, ask, phrases }) {
  return Object.freeze(Object.fromEntries(
    Object.entries(phrases).map(([phraseId, [title, meaning]]) => [phraseId, Object.freeze({
      title,
      heard: heard(title),
      meaning,
      patientContext,
      ask,
    })]),
  ));
}
